<template>
  <div class="empty">
    <i class="whaletrip-icon icon-none"></i>
    <p>{{msg}}</p>
  </div>
</template>
<script type="text/javascript">
 export default {
   data () {
     return {
     }
   },
   props: {
     msg: ''
   }
 }
</script>
<style lang="less">
  .empty{
    padding-top:120px;
    width: 100%;
    height: 400px;
    text-align:center;
    i{
      color: #C04374;
      font-size:50px;
      display: block;
    }
    p{
      font-size:15px;
      color:#6E747D;
      margin-top: 30px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/empty/index.vue